/*------------------------------------*\
    smooth scroll
\*------------------------------------*/

module.exports = function(){


    /*------------------------------------*\
        scroll animations
    \*------------------------------------*/

    $(window).load(function() {

        function animateWaypoint(container, element, direction, startStyle, endStyle, delay, waypointOffset, reverse) {

            $(element).css(startStyle);
            $(container).waypoint(function(direction) {
                if (direction === 'down') {

                    // animate on the way down

                    setTimeout(function() {
                        $(element).css(endStyle);
                    }, delay);

                } else {

                    // if true, reanimate on the way back up

                    if(reverse === true) {
                        $(element).css(startStyle);
                    }
                }
            }, {
                offset: waypointOffset
            });
        }



        // X animation

        animateWaypoint('.js-waypoint-x', '.js-waypoint-x .content__x', 'down', {'display': 'none'}, {'display': 'inline-block'}, 0, '50%', false);

        // Sliding animation

        animateWaypoint('.js-waypoint-slide', '.js-waypoint-slide .block--half', 'down', {'transition': 'transform ease-in-out 0.6s, opacity ease-in-out 0.6s', 'opacity': 0, 'transform': 'translateY(40px)'}, {'opacity': 1, 'transform': 'translateY(0px)'}, 0, '80%', false);

        animateWaypoint('.js-waypoint-slide', '.js-waypoint-slide .block--half.block--staggered', 'down', {'transition': 'all ease 0.8s', 'opacity': 0, 'transform': 'translateY(-40px)'}, {'transform': 'translateY(0px)', 'opacity': 1}, 0, '80%', false);

        // Hero animation

        animateWaypoint('.js-hero-waypoint', '.js-hero-waypoint .hero__caption', 'up', {'transition': 'all ease 1s', 'transform': '', 'opacity': '1'}, {'transform': 'translateY(-40px)', 'opacity': 0}, 0, '-20%', true);

        animateWaypoint('.js-hero-waypoint', '.js-hero-waypoint .hero__caption.hero__caption--right', 'up', {'transition': 'all ease 1s', 'transform': '', 'opacity': '1'}, {'transform': 'translateX(-100%) translateY(-40px)', 'opacity': 0}, 0, '-20%', true);

        animateWaypoint('.js-hero-waypoint', '.js-hero-waypoint .hero__anchor', 'up', {'opacity': ''}, {'opacity': 0}, 0, '-20%', true);

        // Hero fade in

        animateWaypoint('.js-hero-waypoint-2', '.js-hero-waypoint-2 .hero__background', 'down', {'opacity': 0.5}, {'opacity': 1}, 0, '50%', false);

        animateWaypoint('.js-hero-waypoint-2', '.js-hero-waypoint-2 .hero__caption', 'down', {'opacity': ''}, {'opacity': 1}, 0, '50%', false);

        animateWaypoint('.js-hero-waypoint-2', '.js-hero-waypoint-2 .content__heading', 'down', {'transition': 'all ease 0.6s', 'transform': 'translateX(30px)', 'opacity': 0}, {'opacity': 1, 'transform': 'translateX(0px)'}, 0, '30%', false);

        animateWaypoint('.js-hero-waypoint-2', '.js-hero-waypoint-2 .content__paragraph', 'down', {'transition': 'all ease 0.6s', 'transform': 'translateX(-30px)', 'opacity': 0}, {'opacity': 1, 'transform': 'translateX(0px)'}, 400, '30%', false);

        animateWaypoint('.js-hero-waypoint-2', '.js-hero-waypoint-2 .button--over-img', 'down', {'transition': 'all ease 1s', 'opacity': 0}, {'opacity': 1}, 800, '30%', false);

        // Suit Shirt Details

        animateWaypoint('.js-waypoint-suit-shirt-details', '.js-waypoint-suit-shirt-details .suit-shirt-details__intro', 'down', {'transition': 'all ease 1s', 'transform': 'translateY(-40px)', 'opacity': 0}, {'transform': '', 'opacity': 1}, 0, '50%', false);

        animateWaypoint('.js-waypoint-suit-shirt-details', '.js-waypoint-suit-shirt-details .suit-shirt-details__photo', 'down', {'transition': 'all ease 1.6s', 'opacity': 0}, {'opacity': 1}, 400, '50%', false);

        // Photo grid

        animateWaypoint('.js-waypoint-photo-grid', '.js-waypoint-photo-grid .js-waypoint-fast', 'down', {'transition': 'opacity ease 1s, transform ease 1.4s', 'opacity': 0, 'transform': 'translateY(150px)'}, {'opacity': 1, 'transform': 'translateY(0)'}, 0, '80%', false);

        animateWaypoint('.js-waypoint-photo-grid', '.js-waypoint-photo-grid .js-waypoint-normal', 'down', {'transition': 'opacity ease 1s, transform ease 1.4s', 'opacity': 0, 'transform': 'translateY(100px)'}, {'opacity': 1, 'transform': 'translateY(0)'}, 0, '80%', false);

        animateWaypoint('.js-waypoint-photo-grid', '.js-waypoint-photo-grid .js-waypoint-slow', 'down', {'transition': 'opacity ease 1s, transform ease 1.4s', 'opacity': 0, 'transform': 'translateY(50px)'}, {'opacity': 1, 'transform': 'translateY(0)'}, 0, '80%', false);

        // Footer position

        animateWaypoint('.js-footer-waypoint', '.js-footer-waypoint', 'down', {'position': 'absolute'}, {'position': 'fixed'}, 0, '100%', true);


    });


}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/blocks/animate-waypoint.js